import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES, WA_SCHEDULE } from "@/lib/constants";

const CHECKLIST = [
  "Experiência",
  "Atendimento especializado",
  "Equipe profissional",
  "Foco na qualidade de vida",
  "Atendimento humanizado",
];

export const About = () => (
  <section id="clinica" data-testid="about-section" className="bg-white py-20 lg:py-28 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="relative order-2 lg:order-1">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 rounded-[2rem] border border-cob-gold/40 -translate-x-3 -translate-y-3 pointer-events-none" />
              <img loading="lazy" decoding="async"
                src={IMAGES.reception}
                alt="Recepção da Clínica COB"
                data-testid="about-image-main"
                className="relative w-full h-[420px] sm:h-[520px] object-cover rounded-[1.8rem] shadow-[0_30px_70px_-30px_rgba(6,63,50,0.4)]"
              />
              <div className="absolute -top-5 -left-2 sm:-left-5 rounded-2xl bg-cob-dark px-5 py-4 shadow-xl">
                <p className="font-serif text-3xl font-semibold text-cob-gold leading-none">20+</p>
                <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80">
                  anos de cuidado
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="order-1 lg:order-2">
          <SectionHeading
            overline="A Clínica"
            title="Conheça a Clínica COB"
            text="A Clínica COB atua nas áreas de medicina, ortopedia e fisioterapia, oferecendo atendimento especializado e cuidado voltado à saúde, mobilidade e qualidade de vida."
          />
          <Reveal delay={0.2}>
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-cob-muted">
              Desde 2004, nossa missão é cuidar de cada paciente com profissionalismo, atenção e
              compromisso.
            </p>
          </Reveal>
          <ul className="mt-8 space-y-3.5" data-testid="about-checklist">
            {CHECKLIST.map((item, i) => (
              <Reveal key={item} delay={0.22 + i * 0.06}>
                <li className="flex items-center gap-3.5">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cob-dark">
                    <Check className="h-3.5 w-3.5 text-cob-gold" strokeWidth={3} />
                  </span>
                  <span className="text-[15px] font-medium text-cob-ink">{item}</span>
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.5}>
            <a
              href={WA_SCHEDULE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-cta-whatsapp"
              className="mt-9 inline-flex items-center gap-2 text-sm font-semibold text-cob-green transition-colors hover:text-cob-dark group"
            >
              Agende sua consulta
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
